import { Action } from '@ngrx/store';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOAD_USER = 'LOAD_USER';

export class LoginUser implements Action {
  readonly type: string = LOGIN_USER;
  constructor(public payload: string) {}
}

export class LogoutUser implements Action {
  readonly type: string = LOGOUT_USER;
}

export class LoadUser implements Action {
  readonly type: string = LOAD_USER;
}
